import { render } from "./InfrastructureView.vue?vue&type=template&id=5ec701e4&ts=true"
import script from "./InfrastructureView.vue?vue&type=script&lang=ts"
export * from "./InfrastructureView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__